module.exports = __webpack_public_path__ + "img/black-sun.7dd65f59.png";